import { Router } from "@angular/router";
import { ErrorCodes } from "src/app/modules/maintenance/error-codes";

export async function maintenance(
  router: Router,
  { code, message }: { code?: ErrorCodes; message?: string }
): Promise<void> {
  await router.navigate([`/maintenance`], {
    replaceUrl: true,
    skipLocationChange: true,
    queryParams: {
      code,
      message
    }
  });
}
